import type { PadelStandingItem } from '@/services/padelService';
import PadelPlayerAvatar from './PadelPlayerAvatar';

interface PadelStandingRowProps {
  item: PadelStandingItem;
  teamName?: string;
  teamAName?: string;
  teamBName?: string;
  teamAColor?: string;
  teamBColor?: string;
}

const rankBadgeClass = (position: number): string => {
  switch (position) {
    case 1:
      return 'bg-[#FEF3C7] text-[#B45309]';
    case 2:
      return 'bg-[#E5E7EB] text-[#4B5563]';
    case 3:
      return 'bg-[#FFE4D5] text-[#C2410C]';
    default:
      return 'bg-[#F3F4F6] text-[#9CA3AF]';
  }
};

export default function PadelStandingRow({
  item,
  teamName,
  teamAName = 'Tim A',
  teamBName = 'Tim B',
  teamAColor,
  teamBColor,
}: PadelStandingRowProps) {
  const isTeamB = teamName
    ? teamName.trim().toLowerCase() === teamBName.trim().toLowerCase()
    : false;
  const isTeamA = teamName
    ? teamName.trim().toLowerCase() === teamAName.trim().toLowerCase()
    : !isTeamB;

  const rawColor = isTeamA ? teamAColor : teamBColor;
  const isWhite = rawColor?.toUpperCase() === '#FFFFFF';
  const badgeColor = rawColor || (isTeamA ? '#7C4DCC' : '#1E9E5A');
  const badgeBg = isWhite ? '#F3F4F6' : `${badgeColor}1A`;

  return (
    <div className="flex items-center gap-3 border-b border-gray-100 py-3 last:border-b-0">
      <span
        className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-xs font-bold ${rankBadgeClass(
          item.position
        )}`}
      >
        {item.position}
      </span>
      <PadelPlayerAvatar
        name={item.playerName}
        avatarUrl={item.avatarUrl}
        colorKey={String(item.participantId)}
        className="h-9 w-9 flex-shrink-0 text-sm"
      />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 truncate">
          <p className="truncate text-sm font-bold text-gray-900">{item.playerName}</p>
          {teamName && (
            <span
              className="inline-block flex-shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold"
              style={{
                color: isWhite ? '#374151' : badgeColor,
                backgroundColor: badgeBg,
              }}
            >
              {teamName}
            </span>
          )}
        </div>
        <p className="truncate text-[11px] text-gray-400">
          W: {item.wins} · L: {item.losses} · Winrate {item.winRate.toFixed(0)}%
        </p>
      </div>
      <div className="flex-shrink-0 text-right">
        <p className="text-lg font-extrabold leading-none text-[#FF5A1F]">{item.pointsScored}</p>
        <p className="text-[10px] uppercase tracking-wide text-gray-400">poin</p>
      </div>
    </div>
  );
}
